import { usePlanContext } from "../context/plan.context"

const usePlan = () => {
  return usePlanContext()
}

export { usePlan }